import { Alert, Box, CircularProgress } from '@mui/material';

export function LoadingBlock() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 180 }}>
      <CircularProgress size={28} />
    </Box>
  );
}

export function ErrorBlock({ message }: { message: string }) {
  return <Alert severity="error">{message}</Alert>;
}
